import { createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchNotificationSubscribers } from '../../../../entities/Notifications'

export const updateNotificationSubscribers = createAsyncThunk<
	void,
	{ notificationId: string, subscribers: string[] },
	ThunkConfig<string>
>('updateNotificationSubscribers', async (data, thunkAPI) => {

	const { dispatch, extra: { api }, rejectWithValue } = thunkAPI
	const { notificationId, subscribers } = data

	try {
		await api.put(
			`/globalSettings/notifications/${notificationId}/subscribers`,
			subscribers
		)

		showToast({
			type: 'success',
			toastId: 'updateNotificationSubscribers',
			message: 'Success'
		})

		dispatch(fetchNotificationSubscribers(notificationId))
	} catch (e) {
		console.log(e)
		appHandleError(e, 'updateNotificationSubscribers', 'Edit failed')
		return rejectWithValue('Error occurred on editing notification subscribers list')
	}
})
